// extracted by mini-css-extract-plugin
export default {"productProfileTable":"styles_productProfileTable__XJByo","title":"styles_title__HKy9w","header":"styles_header__zJ9UK"};